const palette = {
  scissors: {
    0: 'hsl(39, 89%, 49%)',
    100: 'hsl(40, 84%, 53%)'
  },
  paper: {
    0: 'hsl(230, 89%, 62%)',
    100: 'hsl(230, 89%, 65%)'
  },
  rock: {
    0: 'hsl(349, 71%, 52%)',
    100: 'hsl(349, 70%, 56%)'
  },
  lizard: {
    0: 'hsl(261, 73%, 60%)',
    100: 'hsl(261, 72%, 63%)'
  },
  spock: {
    0: 'hsl(189, 59%, 53%)',
    100: 'hsl(189, 58%, 57%)'
  },
  white: '#fff',
  stop: '#ff3838',
  primary: 'hsl(229, 25%, 31%)',
  secondary: 'hsl(229, 64%, 46%)',
  border: 'hsl(217, 16%, 45%)'
}

export default palette
